export const TRAHANG_DETAIL_INITING           = 'TRAHANG_DETAIL_INITING'
export const TRAHANG_DETAIL_REQUESTING        = 'TRAHANG_DETAIL_REQUESTING'
export const TRAHANG_DETAIL_SUCCESS           = 'TRAHANG_DETAIL_SUCCESS'
export const TRAHANG_DETAIL_ERROR             = 'TRAHANG_DETAIL_ERROR'   

export const TRAHANG_UPDATE_REQUESTING        = 'TRAHANG_UPDATE_REQUESTING'
export const TRAHANG_UPDATE_SUCCESS           = 'TRAHANG_UPDATE_SUCCESS'
export const TRAHANG_UPDATE_ERROR             = 'TRAHANG_UPDATE_ERROR'   

export const TRAHANG_DETAIL_API               = '/api/v1/export/order_details'  
export const TRAHANG_LIST_API                 = ''   
export const TRAHANG_UPDATE_API               = '/api/v1/export/return_order'  


// WEBPACK FOOTER //
// ./src/views/TraHang/constants.js